import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import renderIf from 'render-if';
import './claimed.css';
import {routes} from "../../util/config";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {alertLabels, labels, messages} from "../../util/constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSortUp,faSave,faTimes, faTrashAlt,faEdit} from "@fortawesome/free-solid-svg-icons";
import {
    Button, Divider, ExpansionPanel, ExpansionPanelActions, ExpansionPanelDetails, ExpansionPanelSummary, FormControl,
    Grid, InputLabel, Paper,
    TextField
} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../../components/multiSelect/multiSelect";
import Anomaly from "./anomaly";
import {scrollToBottom, scrollToTop} from "../../util/tools";
import httpHttpsRequest from '../../util/http-request/request';
import { getDataItemsTesisOptions, getClaimedOptions, postClaimedOptions, deleteClaimedOptions } from '../../util/optionsRequest';

class Claimed extends Component {

    constructor(props){
        super(props);

        let group_name ='';
        let group_id ='';
        if (this.props.location != null &&
            this.props.location.state != null &&
            this.props.location.state.component_group_name != null) {
            group_name = this.props.location.state.component_group_name;
            group_id = this.props.location.state.id_group;
        }

        this.state ={
            component_group_name: group_name,
            id_group: group_id,
            itemData: [],
            claimedData: [],
            itemSelected : [],
            itemAliasPT : '',
            itemAliasUS : '',
            itemAliasES : '',
            isEditClaimed : false,
            claimedIdExpanded : []
        }
    };

    componentWillMount(){
        this.getDataItemsTesis();
        this.getDataClaimed();
    };

    clearFields = ()=>{
        this.setState({
            itemAliasPT : '',
            itemAliasUS : '',
            itemAliasES : '',
            itemSelected : [],
        });
    };

    getDataItemsTesis=()=>{
        let param = {'id_group':this.state.id_group};

        let http = new httpHttpsRequest(getDataItemsTesisOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.itemSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    getDataClaimed=()=>{
        let param = {'id_group':this.state.id_group};

        let http = new httpHttpsRequest(getClaimedOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.claimedSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    saveClaimed = () =>{
        let params = {
            id_group : this.state.id_group,
            id_claimed: this.state.itemSelected.value,
            claimed_name_pt : this.state.itemAliasPT,
            claimed_name_us : this.state.itemAliasUS,
            claimed_name_es : this.state.itemAliasES,
            item_tesis_label : this.state.itemSelected.label
        };
        let http = new httpHttpsRequest(postClaimedOptions);
        http.addRequestBody(params);
        http.makeRequest().then((data)=>{this.saveClaimedSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    removeClaimed = (item) =>{
        let confirmDelete = window.confirm(messages.confirmDeleteItem + '\n'+ item.claimed_name_pt );//todo - validar idioma

        if (confirmDelete) {
            let params = {
                id_claimed: item.id_claimed
            };
            let http = new httpHttpsRequest(deleteClaimedOptions);
            http.addQueryString(params);

            http.makeRequest().then((data)=>{this.removeClaimedSuccess(JSON.parse(data))})
                .catch((data)=>{this.callBackError(data)})
        }
    };

    editClaimed = (item) =>{
        scrollToTop();
        this.setState({
            itemAliasPT : item.claimed_name_pt,
            itemAliasUS : item.claimed_name_us,
            itemAliasES : item.claimed_name_es,
            itemSelected : {value:item.id_claimed,label:item.item_tesis_label},
            isEditClaimed : true,
        });
    };

    claimedSuccess = (response) =>{
        if(response.data){
            this.setState({claimedData:response.data});
        }
    };

    saveClaimedSuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.itemSaved, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
            this.clearFields();
            this.getDataClaimed();
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
        this.setState({
            isEditClaimed : false
        });
    };

    removeClaimedSuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.itemRemoved, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
            this.getDataClaimed();
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    itemSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({itemData:response.data});
        }else{
            setAlertOnRedux(true,alertLabels.iconError,messages.getItemsTesisError, alertLabels.alertDanger);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    changeItem = (itemSelected) => {
        if(itemSelected){
            this.setState({itemSelected});
        }
        else{
            this.setState({itemSelected:[]});
        }
    };

    cancelAction = () =>{
        if(this.state.isEditClaimed){
            this.clearFields();
        }else{
            this.props.history.push({
                pathname: routes.groups
            })
        }
        this.setState({
            isEditClaimed : false
        });
    };

    validShowButtonSave = ()=>{
        if(this.state.itemSelected && this.state.itemSelected.value
                && this.state.itemAliasPT.length > 0){
            return (
                <Button variant="contained"  color="primary" onClick={this.saveClaimed}>
                    <FontAwesomeIcon icon={faSave}/> &nbsp;&nbsp;{labels.save}
                </Button>
          );
        }
    };

    validShowLabelItem = () =>{
        if (this.state.itemSelected && this.state.itemSelected.value) {
            return <InputLabel htmlFor="multiSelectItem">{labels.itemSelectedLabel}</InputLabel>;
        } else {
            return <InputLabel htmlFor="multiSelectItem">{labels.selectItem}</InputLabel>
        }
    };

    validShowButtonCancel = (condition)=>{
        if(condition){
            return (
                <Button variant="contained" style={{marginRight: '2%'}} color="secondary" onClick={this.cancelAction}>
                    <FontAwesomeIcon icon={faTimes}/> &nbsp;&nbsp;{labels.cancel}
                </Button>
            );
        }
    };

    showAnomalyItem = (claimed) =>{
        this.state.claimedIdExpanded.push(claimed.id_claimed);
        let newClaimedIdExpanded = this.state.claimedIdExpanded;
        this.setState({claimedIdExpanded:newClaimedIdExpanded});
    };

    validShowAnomalyItem = (claimed) =>{
        if(this.state.claimedIdExpanded.includes(claimed.id_claimed)){
          return  <Anomaly idClaimed={claimed.id_claimed}/>
        }
    };

    validShowLabelNewItem = () =>{
        if (this.state.claimedData.length > 0) {
            return (
                <div className={'div-items'}>
                    <h4> {'\u00A0'} {labels.addNewItem}</h4>
                </div>
            );
        } else {
            return (
                <div className={'div-items'}>
                    <h4> {'\u00A0'} {labels.addFirstItemToGroup}</h4>
                </div>
            );
        }
    };

    render() {

        return (
            <div className="container claimed-padding" >
                {'\u00A0'} <h6>{labels.youEditingItemFromGroup}</h6>
                <h1 className='title-claimed'>  {this.state.component_group_name}</h1>

                {
                    this.validShowLabelNewItem()
                }

                {
                    renderIf(this.state.itemData.length > 0)
                    (

                        <Grid item xs={12} container spacing={8}>
                            <Grid item xs={6}>
                                <Paper >
                                    <div className={'div-paper'}>
                                        {this.validShowLabelItem()}
                                        <MultiSelectField id="multiSelectItem"
                                                          data={this.state.itemData} multi={false} handleSelectChange={this.changeItem}
                                                          valuesSelected={this.state.itemSelected} placeHolder={labels.selectItemPlaceHolder}
                                                          disabled={this.state.isEditClaimed}  />
                                    </div>
                                    <div className={'div-btn'}>
                                        {this.validShowButtonCancel(!(this.state.itemSelected && this.state.itemSelected.value))}
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6}>
                                <Paper>
                                    {
                                        renderIf(this.state.itemSelected && this.state.itemSelected.value)
                                        (
                                            <div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlItem">
                                                        <TextField
                                                            label={labels.itemAliasPT}
                                                            value={this.state.itemAliasPT}
                                                            onChange={(input)=>{this.setState({itemAliasPT:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlItem">
                                                        <TextField
                                                            label={labels.itemAliasUS}
                                                            value={this.state.itemAliasUS}
                                                            onChange={(input)=>{this.setState({itemAliasUS:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlItem">
                                                        <TextField
                                                            label={labels.itemAliasES}
                                                            value={this.state.itemAliasES}
                                                            onChange={(input)=>{this.setState({itemAliasES:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className={'div-btn'}>
                                                    {this.validShowButtonCancel((this.state.itemSelected && this.state.itemSelected.value))}
                                                    {this.validShowButtonSave()}
                                                </div>
                                            </div>
                                        )
                                    }
                                </Paper>
                            </Grid>

                        </Grid>
                    )
                }

                {
                    renderIf(this.state.claimedData.length > 0)
                    (
                        <div className={'div-items'}>
                            <h4> {'\u00A0'} {labels.yourItems}</h4>
                            {
                                this.state.claimedData.map((claimed)=>{
                                    return (
                                    <div key={claimed.id_claimed} className={'expansion-panel'}>
                                        <ExpansionPanel id={claimed.id_claimed} defaultExpanded={false} onChange={()=>{this.showAnomalyItem(claimed); scrollToBottom(claimed.id_claimed);}}>
                                            <ExpansionPanelSummary className={'expansion-header'}  expandIcon={<FontAwesomeIcon icon={faSortUp}/>}>
                                                <div >
                                                    <h5>{claimed.claimed_name_pt}</h5>
                                                </div>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails>
                                                {
                                                    this.validShowAnomalyItem(claimed)
                                                }
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                <Button variant="contained"  color="secondary" onClick={()=>{this.removeClaimed(claimed)}}>
                                                    <FontAwesomeIcon icon={faTrashAlt}/> &nbsp;&nbsp;{labels.removeItem}
                                                </Button>
                                                <Button variant="contained"  color="primary" onClick={()=>{this.editClaimed(claimed);}}>
                                                    <FontAwesomeIcon icon={faEdit}/> &nbsp;&nbsp;{labels.editItem}
                                                </Button>
                                            </ExpansionPanelActions>
                                        </ExpansionPanel>
                                    </div>)
                                })
                            }
                        </div>

                    )
                }
            </div>
        )
    }
}


export default withRouter(Claimed);


// WEBPACK FOOTER //
// ./src/containers/cst_group/claimed.js